import { TYPE_INSCRIPTION } from "../constants";

const getTypeInscription = (inscription) => {
  if (inscription?.individual) return TYPE_INSCRIPTION.INDIVIDUAL;
  else return TYPE_INSCRIPTION.GROUP;
};

export default getTypeInscription;
